module.exports = __webpack_public_path__ + "media/bootstrap-icons/bag-x-fill-1d21afc7.svg";